import { Record } from './record';

export class ExtractAccount {
	balance: number;
	balanceFinal: number;
	records: Array<Record>;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/extract/models/extract-account.ts